/**
 * 基础配置
 */
export default {
  // 品牌
  BRAND_CODE: 'SHI',

  // 接口请求地址
  BASE_URL: process.env.VUE_APP_API_BASE_URL,

  // 腾讯地图地址
  MAP_BASE_URL: 'https://apis.map.qq.com',

  // 腾讯地图key
  MAP_KEY: 'WHYBZ-FNW32-CXNUG-C6G2Q-5NULF-RZB47'
}
